import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import UnderDevelopment from '../../assets/under-construction.svg';
import ToolTipIcon from '../../assets/info-icon.svg';

// Define the component props
interface WidgetProps {
	title: any;
	tooltipLabel: string;
	height?: string;
	bgColor?: string;
	textColor?: string;
}

const InprogressWidget: React.FC<WidgetProps> = ({ title, tooltipLabel, height, bgColor, textColor}) => {
	return (
		<Box
			sx={{
				backgroundColor: bgColor || '#003771',
				display: 'flex',
				flexDirection: 'row',
				color: textColor || 'white',
				padding: '16px',
				height: height || '170px'
			}}
		>
			<Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
				<Typography variant="widgetTitle" sx={{ color: textColor || 'white' }}>
					{title}
				</Typography>
				<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'normal' }}>
					<Box component="img" src={UnderDevelopment} alt={tooltipLabel} maxHeight={'20%'}/>
					<Typography sx={{marginLeft: '5px', color: textColor || 'white'}}>{tooltipLabel}</Typography>
					<Tooltip title={tooltipLabel} arrow>
						<img src={ToolTipIcon} alt={tooltipLabel} style={{height: '15px', width: '15px', margin:'5px 10px'}}/>
					</Tooltip>
				</Box>
			</Box>
		</Box>
	);
};

export default InprogressWidget;
